module.exports = __webpack_public_path__ + "static/media/Damian-preview.fb165b40.jpg";